import { render, staticRenderFns } from "./VariantZiskTextBox.vue?vue&type=template&id=16bed62a&"
import script from "./VariantZiskTextBox.vue?vue&type=script&lang=js&"
export * from "./VariantZiskTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16bed62a')) {
      api.createRecord('16bed62a', component.options)
    } else {
      api.reload('16bed62a', component.options)
    }
    module.hot.accept("./VariantZiskTextBox.vue?vue&type=template&id=16bed62a&", function () {
      api.rerender('16bed62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/produkt/VariantZiskTextBox.vue"
export default component.exports